import { async, createTypes } from 'redux-action-creator';

export default createTypes([
  ...async('GET_HOMEPAGE_DATA'),
], 'HOME');



// WEBPACK FOOTER //
// ./src/app/actions/home/types.js